import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const getOrders = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_all_order/${payload?.status}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleAdminOrder = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_admin_order/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editAdminOrder = async (payload) => {
  try {
    const response = await APIs.patch(
      `/edit_admin_order/${payload?.orderId}`,
      payload
    );

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editAdminPaymentOrder = async (payload) => {
  try {
    const response = await APIs.patch(
      `/edit_admin_payment_order/${payload?.orderId}`,
      payload
    );

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAUsersOrders = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_a_user_order/${payload?.id}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAUsersStatusOrders = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_a_user_status_count_order/${payload?.id}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getStatusOrders = async (payload) => {
  try {
    const response = await APIs.get(`/get_status_count_order`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllCountOrders = async (payload) => {
  try {
    const response = await APIs.get(`/get_all_count_order`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const SearchForOrderByName = async (payload) => {
  try {
    const response = await APIs.get(
      `/search_for_order_by_name/${payload?.name}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const adminOrderServices = {
  getOrders,
  getSingleAdminOrder,
  editAdminOrder,
  getAUsersOrders,
  getAUsersStatusOrders,
  getStatusOrders,
  editAdminPaymentOrder,
  getAllCountOrders,
  SearchForOrderByName,
};

export default adminOrderServices;
